import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { CalendarDropdownComponent } from './calendar-dropdown.component';
import { ErrorTooltipModule } from '../../atoms/error-tooltip/error-tooltip.module';
import { ActionLabelModule } from '../action-label/action-label.module';
import { CalendarSingleModule } from '../calendar-single/calendar-single.module';

@NgModule({
  imports: [
    ErrorTooltipModule,
    CommonModule,
    ActionLabelModule,
    CalendarSingleModule
  ],
  declarations: [CalendarDropdownComponent],
  exports: [CalendarDropdownComponent]
})
export class CalendarDropdownModule {}
